import { useQuery } from "@tanstack/react-query";
import { Button } from "@rumbledirect/ui";
import { Space } from "antd";
import { fetchCompanies } from "../../../lib/api/resources/companies";
import { companyColumns } from "./lib/constants/companyColumns";
import { FileExcelOutlined, PlusOutlined } from "@ant-design/icons";
import { useState } from "react";
import { Link } from "react-router-dom";
import { Table } from "@/components/v2";

export const CompanyList = () => {
  const [page, setPage] = useState(1);

  const companiesQuery = useQuery({
    queryKey: ["companies", page],
    queryFn: () => fetchCompanies({ page }),
  });

  return (
    <div>
      <Space
        style={{ marginBottom: 16, width: "100%", justifyContent: "flex-end" }}
      >
        <Link to="/companies/import">
          <Button icon={<FileExcelOutlined />}>Importeren</Button>
        </Link>
        <Link to="/companies/create">
          <Button icon={<PlusOutlined />}>Nieuw bedrijf</Button>
        </Link>
      </Space>
      <Table
        columns={companyColumns}
        dataSource={companiesQuery.data?.member}
        loading={companiesQuery.isLoading}
        pagination={{
          pageSize: 15,
          total: companiesQuery.data?.totalItems,
          showSizeChanger: false,
          onChange: (page) => setPage(page),
        }}
        rowKey="id"
      />
    </div>
  );
};
